export default __webpack_public_path__ + "static/media/password.9c55e625.svg";